import { jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps, TypographyBlock, Box } from "@wsui/base";
import "react";
function FormModuleCustomContentField(props) {
  props = useThemeProps({
    props,
    name: "FormModuleCustomContentField"
  });
  let {
    field: {
      content
      // conditionalLogic,
      // conditonalField,
    },
    as: Component = Box,
    ...restProps
  } = props;
  return /* @__PURE__ */jsx(Component, {
    ...restProps,
    children: /* @__PURE__ */jsx(TypographyBlock, {
      children: content
    })
  });
}
export { FormModuleCustomContentField as default };